function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMccGas = function SvgMccGas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 7a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v10.65c3.423.695 6 3.722 6 7.35v3.25a1.25 1.25 0 1 0 2.5 0V20l-2.11-1.406a2 2 0 0 1-.89-1.664v-5.516a1 1 0 0 0-.293-.707L28.5 9a1.414 1.414 0 1 1 2-2l5.414 5.414a2 2 0 0 1 .586 1.414V28.25a4.25 4.25 0 0 1-8.5 0V25a4.502 4.502 0 0 0-3-4.244V32a1 1 0 0 0 1 1 1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1 1 1 0 0 0 1-1V7Zm4 0h12v10H9V7Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccGas;